import {Injectable} from '@angular/core';
import {catchError, first, Observable, of, shareReplay} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {DataResponses, ModulesScreens} from "../const/mock-data";
import {RouterLinks} from "../enums/router-links";
import {Module} from "../models/module.model";
import {ApiService} from "../services/api.service";
import {tap} from "rxjs/operators";
import {ScreenTypes} from "../enums/screen-types";

@Injectable({
  providedIn: 'root'
})

export class SharedHelper {
  globalTexts: any;
  modules!: Observable<(Module | undefined)[]>; // Change the type here
  resp_all_modules!: any;


  constructor(
    private http: HttpClient,
    private router: Router,
    private apiService: ApiService,
  ) {
  }

  groupBy(list: any[], keyGetter: any) {
    console.log("groupBy list => ", list);
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  getGlobalTexts(): Observable<any> {
    if (!this.globalTexts) {
      this.globalTexts = this.http.get("../../assets/jsons/global-texts.json").pipe(
        shareReplay(1));
    }
    return this.globalTexts;
  }


  constructMenu(_enum1: any, _enum2: any, _enum3: any | null = null, _enum4: any | null = null): any {
    let menu = [];
    for (let key of Object.keys(_enum1)) {
      menu.push({
        label: _enum1[key as keyof typeof _enum1],
        path: _enum2[key as keyof typeof _enum2],
        icon: (_enum3) ? _enum3[key as keyof typeof _enum3] : null,
        status: (_enum4) ? _enum4[key as keyof typeof _enum4] : null,
      });
    }

    return menu;
  }

  getModuleUuidFromUrl(): string {
    let pathname: string = window.location.pathname;
    const parts = pathname.split('/');
    return parts[parts.length - 3];
  }

  getRespApiAllModules(): Observable<any> {
    return this.apiService.getModules();
  }

  getModulesData(): Observable<Module[]> {
    return this.getRespApiAllModules().pipe(
      tap((response: any) => {
        // Assign the response to this.modules for future use
        this.resp_all_modules = response;
        console.log(this.resp_all_modules);
      })
    );
  }

  async getModule(): Promise<Module | undefined> {
    const _module_uuid = this.getModuleUuidFromUrl();
    let modules: Module[] = [];
    let module!: Module | undefined;

    const modulesData: any = await this.getModulesData().toPromise();

    if (modulesData) {
      modules = modulesData.data;
      console.log("getModulesData modules => ", modules);

      if (modules && modules.length > 0) {
        module = modules.find((m: any) => m.module_uuid === _module_uuid);
      }
      console.log("module => ", module);
    }
    return module;
  }

  getRefPageFromUrl(): string {
    let pathname: string = window.location.pathname;
    const parts = pathname.split('/');
    return parts[parts.length - 1];
  }

  getCurrentScreen(): any {
    let mod_info = this.getFrontDatasForModuleByUuid(this.getModuleUuidFromUrl());
    if (!mod_info) return;
    let module_screens = mod_info.screens;
    let ref_page = this.getRefPageFromUrl();
    return module_screens.find((s: any) => s.ref === ref_page);
  }

  getCurrentScreenParam(_param: string): any {
    let screen = this.getCurrentScreen();
    if (!screen || !_param) return;
    return screen[_param];
  }

  getCurrentScreensTypeQst(): any {
    let mod_info = this.getFrontDatasForModuleByUuid(this.getModuleUuidFromUrl());
    if (!mod_info) return;
    return mod_info.screens.filter((s: any) => s.type === ScreenTypes.Question);
  }


  // Function to get the Object in DataResponses that has the id equal to the given id (qst_id)
  getOtherDatasForQstByRef(qst_ref: string): any {
    return DataResponses.find((q: any) => q.ref === qst_ref);
  }

  getFrontDatasForModuleByUuid(module_uuid: string): any {
    // console.log("ModulesScreens => ", ModulesScreens);
    // console.log("module_uuid => ", module_uuid);
    return ModulesScreens.find((m: any) => m.module_uuid === module_uuid);
  }

  async getTitleInTextsCommonSections(_titleKey: string): Promise<any> {
    // Get the titles from the texts-common-sections.ts
    const common_texts: any = await import('../const/texts-common-sections');
    if (!common_texts) return null;

    const common_titles = common_texts.titles;

    // Find the key in common_titles that corresponds to the _titleKey and returns the value
    return common_titles[_titleKey];
  }

  async getResponseByLabel(label: string): Promise<any> {
    const responses = await this.http.get<any[]>('../../assets/jsons/responses.json').toPromise();
    console.log("getResponseByLabel responses => ", responses, responses?.find(resp => resp.resp_label === label));
    return responses?.find(resp => resp.resp_label === label);
  }

  // Function to get the Question from the server
  async getQuestion(_ref: string): Promise<any> {
    // If current url includes '/question/', we return
    if (!this.router.url.includes('/question/')) return;

    return new Promise((resolve, reject) => {
      this.apiService.getQuestionByRef(_ref).pipe(
        first(),
        catchError(error => {
          console.error('Error occurred:', error);
          return of(null); // return a safe value or an Observable that does not error
        })).subscribe(async (response: any) => {
        if (response && response?.data) {
          ///console.log("getQuestionByRef response => ", response);
          let question = response.data;

          // Get of questions in json
          const questions: any[] | undefined = await this.http.get<any[]>('../../assets/jsons/questions.json').toPromise();
          //console.log("getQuestionByRef questions => ", questions);
          let qst_json = questions?.find((q: any) => {
            return q.qst_ref_bdd === _ref;
          });

          // Get the label from questions.json
          question.label = qst_json?.label;

          // if (qst_json.instructions_text && qst_json.label.includes('##INSTRUCTIONS_TEXT##')) {
          //   question.label = qst_json?.label.replace('##INSTRUCTIONS_TEXT##', qst_json.instructions_text);
          // } else {
          //   question.label = qst_json?.label;
          // }

          // Get the title from the texts-common-sections.ts
          if (qst_json?.title?.includes('##COMMON_TITLE##')) {
            // Split the title by '##COMMON_TITLE##'
            let title_key = qst_json.title.split('##COMMON_TITLE##')[1];
            // Get the title from the texts-common-sections.ts
            question.title = await this.getTitleInTextsCommonSections(title_key);
          }

          console.log("getQuestionByRef question => ", question);
          resolve(question);
        } else {
          reject('Invalid getQuestion');
        }
      });
    });
  }

  async getModuleForQst() {
    const module = await this.getModule();
    return module ? module.module_id : 0;
  }

  getStatusClass(_status: number | undefined) {
    let status_class = '';
    switch (_status) {
      case 0:
        status_class = 'disabled';
        break;
      case 1:
      case null:// hard code
        status_class = 'active';
        break;
      case 2:
        status_class = 'completed';
        break;
    }
    return status_class;
  }

  getErrorMessage(param: string, global_texts: any, f: any) {
    console.log("getErrorMessage param ==> ", param, f);
    if (f[param]?.errors?.required) {
      return global_texts.error_messages.validator_required;
    } else if (f[param]?.errors?.requiredTrue) {
      console.log("requiredTrue error is present");
      return global_texts.error_messages.validator_required_true;
    } else if (f[param]?.errors?.mustMatch) {
      if (param.indexOf('confirm_pass') != -1) {
        return global_texts.error_messages.validator_mustmatch;
      }
    } else if (f[param]?.errors?.pattern) {
      if (param.indexOf('password') != -1) {
        return global_texts.error_messages.validator_password;
      } else if (param.indexOf('email') != -1) {
        return global_texts.error_messages.validator_email;
      }
    }
    return '';
  }

  getRouteToNavigate(_screen: any): string {
    let routeToNavigate = '';
    switch (_screen.type) {
      case ScreenTypes.Intro:
        routeToNavigate = RouterLinks.ModuleIntro + '/' + _screen.ref;
        break;
      case ScreenTypes.Explanation:
        routeToNavigate = RouterLinks.ModuleExplanation + '/' + _screen.ref;
        break;
      case ScreenTypes.Question:
        routeToNavigate = RouterLinks.Questions + '/' + _screen.ref;
        break;
      case ScreenTypes.End:
        routeToNavigate = RouterLinks.ModuleEnd + '/' + _screen.ref;
        break;
    }
    return routeToNavigate;
  }

  startOrContinueModule(_module_uuid: string): void {
    console.log("startOrContinueModule _module_uuid => ", _module_uuid);
    // CALL new api to get the qst_ref of last answer of the user for this module
    this.apiService.getQstRefLastAnswered(_module_uuid).subscribe((response: any) => {
      console.log("getLastRefQuestion response => ", response);
      // if the user has already answered a question, we redirect to the next screen of last question answered screen
      if (response?.data) {
        console.log("getLastRefQuestion error => ", response.data);
        let last_qst_ref = response.data;
        // Get the las question screen object from the module screens
        let module_screens = this.getFrontDatasForModuleByUuid(_module_uuid)?.screens;
        // Get the index in array of the current screen by ref and type
        let current_screen_index = module_screens.findIndex((s: any) => s.ref === last_qst_ref);
        // Get the next and previous screen object
        let index_to_go = current_screen_index + 1;
        let screen_to_go = module_screens[index_to_go];
        let routeToNavigate = this.getRouteToNavigate(screen_to_go) || '';
        routeToNavigate = routeToNavigate.replace(':uuid', _module_uuid);
        this.router.navigate([routeToNavigate]);
      }
      // else we redirect to the first screen of the module
      else {
        this.goToFirtScreen(_module_uuid);
      }
    }, (error: any) => {
      console.log("getLastRefQuestion error => ", error);
    });
  }

  goToFirtScreen(_module_uuid: string): void {
    let mod_info = this.getFrontDatasForModuleByUuid(_module_uuid);
    if (!mod_info) return;

    let first_screen = mod_info.screens[0];
    let routeToNavigate = this.getRouteToNavigate(first_screen) || '';

    routeToNavigate = routeToNavigate.replace(':uuid', _module_uuid);
    this.router.navigate([routeToNavigate]);
  }

  startModule(_module_uuid: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService.startModule(_module_uuid).subscribe((response: any) => {
        console.log("startModule response => ", response);
        if (response?.data) {
          console.log("startModule data => ", response.data);
        }
        resolve(response);
      }, (error: any) => {
        console.log("startModule error => ", error);
        reject(error);
      });
    });
  }

  finishModule(_module_uuid: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService.finishModule(_module_uuid).subscribe((response: any) => {
        console.log("finishModule response => ", response);
        if (response?.data) {
          console.log("finishModule data => ", response.data);
        }
        resolve(response);
      }, (error: any) => {
        console.log("finishModule error => ", error);
        reject(error);
      });
    });
  }

  async goToNextScreen(_next_or_prev: string = 'next'): Promise<void> {
    // Get the module screens
    let mod_info = this.getFrontDatasForModuleByUuid(this.getModuleUuidFromUrl());
    let module_screens = mod_info.screens;
    let screen_ref = this.getRefPageFromUrl();

    // Get the index in array of the current screen by ref and type
    let current_screen_index = module_screens.findIndex((s: any) => s.ref === screen_ref);

    // Get the index of the next screen from currentScreenIndex
    let index_to_go = (_next_or_prev == 'next') ? current_screen_index + 1 : current_screen_index - 1;

    // Get the next and previous screen object
    let screen_to_go = module_screens[index_to_go];

    let routeToNavigate = '';
    // Redirect to the next screen
    if (index_to_go < module_screens.length) {
      routeToNavigate = this.getRouteToNavigate(screen_to_go);
    }
    // Redirect to the module list
    else {
      // Redirect to the Modules list page but before saving the module as finished
      await this.finishModule(this.getModuleUuidFromUrl());
      routeToNavigate = RouterLinks.ModulesList;
    }

    console.log("current_screen_index => ", current_screen_index);
    if (current_screen_index == 0) await this.startModule(this.getModuleUuidFromUrl());

    routeToNavigate = routeToNavigate.replace(':uuid', this.getModuleUuidFromUrl().toString());

    this.router.navigate([routeToNavigate]);
  }
}
